export default __webpack_public_path__ + "cdab809dceb3010b84be4432b668f4ad.jpg";